module.exports = __webpack_public_path__ + "img/fallback_040_p.ddc27946.jpg";